import styles from "./VersionTag.module.css"

/**
 * The version a module, template or note is at, shown beside its name. Not in
 * the design system: quieter than a Tag, outlined and in sentence case, so it
 * reads as a fact about the thing named rather than a label on it.
 */
export function VersionTag({ version }: { version: number }) {
  return <span className={styles.version}>Version {version}</span>
}
